module.exports = __webpack_public_path__ + "static/media/26.32fb6bb2.jpg";